







































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import HasValidation from "@/mixins/HasValidation";
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { BrandConfigKeys } from "@/data/constants";
import { DataModules } from "@/store/modules/data";

// Types
import { IClient } from "@/models/clients";

@Component({
  components: {
    "default-value-field": () =>
      import("@/components/app/global/fields/defaultValueField.vue")
  }
})
export default class ClientDueDateForm extends Mixins(
  HasValidation,
  RequestPromises
) {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: false })
  public isSticky!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public form = {} as Pick<
    IClient,
    "before_due_date_charge_interval" | "before_due_date_charge_interval_dd"
  >;

  public isLoading = true;
  public isReloading = false;
  public requestError = false;
  public isProcessing = false;

  // Life-cycle methods

  public created() {
    this.loadData();
  }

  // Methods

  public async loadData() {
    try {
      await this.getBrandSettings();
      this.initialiseForm();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public getBrandSettings() {
    return this.$store.dispatch("brand/getConfig", {
      brandId: this.client.brand_id,
      keys: [
        BrandConfigKeys.BILLING_AUTOMATION_CHARGE_INTERVAL,
        BrandConfigKeys.BILLING_AUTOMATION_CHARGE_INTERVAL_DD
      ]
    });
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public initialiseForm() {
    this.form = this.initForm();
  }

  public initForm() {
    return _.pick(this.client, [
      "before_due_date_charge_interval",
      "before_due_date_charge_interval_dd"
    ]);
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;
      await this.updateClient();

      this.$emit("refreshClient");

      if (!this.isSticky) {
        this.$store.dispatch("toast/show", {
          message: this.$t(
            "_sentence.invoice.consolidation_preferences_updated"
          )
        });
      }
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public updateClient() {
    if (!this.formIsChanged) return Promise.resolve();

    return this.$store.dispatch(`data/${DataModules.CLIENTS}/update`, {
      id: this.clientId,
      data: this.form,
      vm: this
    });
  }

  public revertToInitialState() {
    this.initialiseForm();
  }

  // Computed

  public get clientId() {
    return this.client.id;
  }

  public get chargeIntervalBOS() {
    return this.$store.getters["brand/config"][
      BrandConfigKeys.BILLING_AUTOMATION_CHARGE_INTERVAL
    ];
  }

  public get chargeIntervalDDBOS() {
    return this.$store.getters["brand/config"][
      BrandConfigKeys.BILLING_AUTOMATION_CHARGE_INTERVAL_DD
    ];
  }

  public get isStaged() {
    return !!this.client?.staged_import;
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsChanged || this.hasErrors;
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.initForm());
  }

  // Guarding

  public get canUpdate() {
    return this.$userCan("update_client");
  }

  // Watchers

  @Watch("client")
  public onClientDataChange() {
    this.initialiseForm();
  }

  @Watch("formIsChanged")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.formIsChanged);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);

    if (!this.isProcessing && !this.hasErrors) {
      this.$emit("isEnabled", false);
    }
  }
}
